import { ECLEAR_OPTION_CATEGORY } from '@enechain/eposition-ui/src/models/eclearOption'

import { Maybe } from '~/types/AdvancedTypes'

import { ResultAvailableDealSimulationForOption1Models } from './ResultAvailableDealSimulationDetailForOption1Models'
import { ResultAvailableDealSimulationForOption2Models } from './ResultAvailableDealSimulationDetailForOption2Models'

export type ResultAvailableDealSimulationDetailResult = Maybe<
  | ResultAvailableDealSimulationForOption1Models
  | ResultAvailableDealSimulationForOption2Models
>

export function isOption1Result(
  result: ResultAvailableDealSimulationDetailResult,
): result is ResultAvailableDealSimulationForOption1Models {
  return result?.type === ECLEAR_OPTION_CATEGORY.OPTION_1
}

export function isOption2Result(
  result: ResultAvailableDealSimulationDetailResult,
): result is ResultAvailableDealSimulationForOption2Models {
  return result?.type === ECLEAR_OPTION_CATEGORY.OPTION_2
}
